import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-24 px-4 relative overflow-hidden flex items-center justify-center text-center" data-id="element-96">
      {/* Background Gradients */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050510] to-[#0a0a1f] z-0" data-id="element-97" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-[120px] animate-pulse" data-id="element-98" />

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-99">
        <ScrollReveal data-id="element-100">
          <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-101">
            Hoy puedes seguir consumiendo contenido... <br data-id="element-102" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-400" data-id="element-103">
              o empezar a construir ingresos.
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-104">
          <p className="text-2xl text-white mb-10 font-medium" data-id="element-105">
            La decisión es tuya.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.4} data-id="element-106">
          <div className="glass-card p-8 md:p-12 rounded-3xl inline-block w-full max-w-2xl border border-cyan-500/30 shadow-[0_0_60px_rgba(0,212,255,0.15)]" data-id="element-107">
            <div className="flex flex-col items-center gap-6" data-id="element-108">
              <div className="flex items-baseline gap-3" data-id="element-109">
                <span className="text-gray-500 line-through text-2xl" data-id="element-110">$97</span>
                <span className="text-5xl md:text-6xl font-bold text-white tracking-tight" data-id="element-111">
                  $16.39
                </span>
              </div>

              <CTAButton text="EMPEZAR AHORA" size="lg" fullWidth className="text-xl py-5" data-id="element-112" />

              <div className="flex items-center gap-4 text-sm text-gray-400 mt-2" data-id="element-113">
                <span className="flex items-center gap-1" data-id="element-114">🔒 Pago Seguro</span>
                <span className="w-1 h-1 bg-gray-600 rounded-full" data-id="element-115" />
                <span className="flex items-center gap-1" data-id="element-116">
                  ⚡ Acceso Inmediato
                </span>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}